module.exports = __webpack_public_path__ + "img/logo-anewday_1full_color.e66eaab6.webp";